import React, {useState, useEffect} from 'react';
import {isEqual} from 'lodash';
import { useFetcher } from "fetcher!sofe";
import {CpDropdown} from 'canopy-styleguide!sofe';
import ClientMenuTrigger from './client-menu-dropdown/client-menu-trigger.component';
import ClientMenuContent from './client-menu-dropdown/client-menu-content.component';

export default function ClientMenu(props) {
  const {
    user,
    clients,
    activeClient,
    hasCanopyPayments,
    customLinks,
    companyWebsiteLink,
  } = props;
  const [userEntity, setUserEntity] = useState({})

  const { loading, results: entities, error, refetch } = useFetcher(`/wg/entities?role=Client`, { pluck: 'users' })

  useEffect(() => {
    if (entities && Array.isArray(entities)) {
      const found = entities.find(e => e.id === user.id)
      if (!isEqual(found, userEntity)) {
        setUserEntity(found)
      }
    }
  }, [entities])

  return (
    <CpDropdown
      position="bottom-end"
      allowContentClicks
      renderContent={({close}) => (
        <ClientMenuContent
          user={user}
          activeClient={activeClient}
          hasCanopyPayments={hasCanopyPayments}
          entities={entities}
          userEntity={userEntity}
          clients={clients}
          customLinks={customLinks}
          companyWebsiteLink={companyWebsiteLink}
          close={close}
        />
      )}
      renderTrigger={({toggle, isOpen }) => (
        <ClientMenuTrigger toggle={toggle} userEntity={userEntity} activeClient={activeClient} isOpen={isOpen} />
      )}
      contentWidth={396}
      contentHeight={400}
    />
  );
}
